module.exports = __webpack_public_path__ + "static/img/cxye_selected_image.6c4ad82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/cxye_selected_image.png
// module id = rklK
// module chunks = 44